import React from "react";
import { buildServiceStructuredData, StructuredData } from "../StructuredData";

export interface ServiceStructuredDataProps {
  serviceType: string;
}

export function ServiceStructuredData({
  serviceType,
}: ServiceStructuredDataProps) {
  const serviceStructuredData = buildServiceStructuredData({
    serviceType,
  });
  return <StructuredData structuredData={serviceStructuredData} />;
}
